import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function RegionalAgentRegister() {
  const [step, setStep] = useState(1)
  const [regions, setRegions] = useState([])
  const [form, setForm] = useState({
    name: '', phone: '', password: '', idCard: '', regionLevel: 'province', regionId: '', regionName: '', recommendCode: ''
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [result, setResult] = useState(null)
  const [referrerId, setReferrerId] = useState('')

  // 从URL获取推荐人ID
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    if (ref) {
      setReferrerId(ref)
      fetch(`${API}/partners/lookup?code=${ref}`)
        .then(r => r.json())
        .then(d => {
          if (d.success && d.data) {
            setForm(prev => ({ ...prev, recommendCode: ref }))
          }
        })
        .catch(e => { console.error(e) })
    }
  }, [])

  // 根据推荐码查找推荐人
  const lookupReferrer = async (code) => {
    if (!code || code.length < 4) {
      setReferrerId('')
      return
    }
    try {
      const res = await fetch(`${API}/partners/lookup?code=${code}`)
      const d = await res.json()
      if (d.success && d.data) {
        setReferrerId(d.data.id)
      } else {
        setReferrerId('')
      }
    } catch (e) {
      setReferrerId('')
    }
  }

  const handleRecommendCodeChange = (value) => {
    setForm({ ...form, recommendCode: value })
    lookupReferrer(value)
  }

  const agentConfig = {
    province: { name: '省级代理', fee: 50000, recommendBonus: '一级40%+二级10%', manageBonus: '10%' },
    city: { name: '市级代理', fee: 20000, recommendBonus: '一级30%+二级10%', manageBonus: '8%' },
    county: { name: '县级代理', fee: 5000, recommendBonus: '一级20%', manageBonus: '5%' }
  }

  const currentConfig = agentConfig[form.regionLevel]
  
  // 根据代理级别过滤区域
  const filteredRegions = regions.filter(r => {
    if (form.regionLevel === 'province') return r.level === 'province'
    if (form.regionLevel === 'city') return r.level === 'city'
    if (form.regionLevel === 'county') return r.level === 'district' // 县级代理选择区县区域
    return true
  })

  useEffect(() => {
    fetchRegions()
  }, [])

  const fetchRegions = async () => {
    try {
      const res = await fetch(`${API}/regional-agents/config/regions`)
      const d = await res.json()
      if (d.success) {
        setRegions(d.data.regions || [])
      }
    } catch (e) {
      console.error('获取区域失败', e)
    }
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) { alert('请输入姓名'); return }
    if (!form.phone || !/^1\d{10}$/.test(form.phone)) { alert('请输入正确的手机号'); return }
    if (!form.password || form.password.length < 6) { alert('请输入至少6位密码'); return }
    if (!form.regionId) { alert('请选择代理区域'); return }
    
    setLoading(true)
    try {
      const res = await fetch(`${API}/regional-agents`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({...form, password: form.password || '123456', referrer: referrerId})
      })
      const d = await res.json()
      if (d.success) {
        setResult(d.data)
        setSuccess(true)
      } else {
        alert(d.error || '申请失败')
      }
    } catch (e) {
      alert('申请失败')
    }
    setLoading(false)
  }

  if (success && result) {
    return (
      <div style={{ padding: 40, maxWidth: 600, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
          <h2 style={{ fontSize: 24, color: '#52c41a', marginBottom: 16 }}>恭喜！申请成功！</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>
            您已成为 <strong style={{ color: '#fa8c16', fontSize: 18 }}>{result.region_name}</strong> {result.region_level}！
          </p>
          
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12, color: '#fa8c16' }}>🎁 您已获得全部权益：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14, color: '#666' }}>
              <div>✅ <strong>区域独家代理权</strong>（该区域唯一代理）</div>
              <div>✅ <strong>自动获得推广员资格</strong>（自己做推广享80%佣金）</div>
              <div>✅ <strong>推荐奖</strong>（招募认证/机构推广员{currentConfig.recommendBonus}）</div>
              <div>✅ <strong>管理奖</strong>（下线所有业绩{currentConfig.manageBonus}）</div>
              <div>✅ <strong>永久续费奖励</strong>（下级续费的5%）</div>
            </div>
          </div>
          
          <div style={{ background: '#f6ffed', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12 }}>代理信息：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14 }}>
              <div>代理ID：<strong>{result.agent_id}</strong></div>
              <div>代理区域：{result.region_name}</div>
              <div>代理级别：{result.region_level}</div>
              <div>代理费：¥{result.agent_fee.toLocaleString()}</div>
              <div>服务期限：1年（{result.days_left}天）</div>
            </div>
          </div>

          <div style={{ background: '#e6f7ff', borderRadius: 8, padding: 16, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: '#666' }}>
              <strong>📝 登录说明：</strong>
              <ul style={{ margin: '8px 0 0', paddingLeft: 20, lineHeight: 1.8 }}>
                <li>登录账号：您的手机号</li>
                <li>初始密码：agent + 手机号后6位</li>
                <li>登录地址：api.boxiaotu.cn/agent</li>
              </ul>
            </div>
          </div>

          <div style={{ background: '#fff1f0', borderRadius: 8, padding: 16, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: '#cf1322' }}>
              <strong>⏰ 下一步：</strong>
              <ul style={{ margin: '8px 0 0', paddingLeft: 20, lineHeight: 1.8 }}>
                <li>请联系客服缴纳代理费 {result.agent_fee.toLocaleString()} 元</li>
                <li>缴费后即可开通代理后台</li>
              </ul>
            </div>
          </div>

          <button onClick={() => window.location.href = 'https://api.boxiaotu.cn/cms/?page=regional-agents'} style={{ padding: '12px 32px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
            完成
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ paddingTop: 80, padding: 40 }}>
      {/* 顶部功能栏 */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'#1890ff',color:'#fff',marginBottom:16,borderRadius:8,position:'sticky',top:0,zIndex:100}}>
        <button onClick={()=>window.location.href='/cms/'} style={{padding:'8px 16px',background:'rgba(255,255,255,0.2)',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,position:'relative',zIndex:101}}>← 返回</button>
        <span style={{fontSize:13}}>邀请他人申请</span>
        <button onClick={()=>{var ref=referrerId||new URLSearchParams(window.location.search).get('ref')||'';var l=ref?window.location.origin+'/?page=regional-agent-register&ref='+ref:window.location.origin+'/?page=regional-agent-register';navigator.clipboard.writeText(l).then(()=>alert('已复制!')).catch(()=>prompt('复制:',l))}} style={{padding:'8px 16px',background:'#fff',color:'#1890ff',border:'none',borderRadius:6,cursor:'pointer',fontWeight:600,fontSize:13}}>复制链接</button>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h2 style={{ fontSize: 24, marginBottom: 8 }}>区域代理申请</h2>
          <p style={{ color: '#666' }}>成为博小兔区域独家代理，开启财富之旅</p>
        </div>

        {/* 代理级别选择 */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, marginBottom: 20 }}>
          <h3 style={{ marginBottom: 16 }}>选择代理级别</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            {Object.entries(agentConfig).map(([key, config]) => (
              <div
                key={key}
                onClick={() => setForm({ ...form, regionLevel: key, regionId: '', regionName: '' })}
                style={{
                  padding: 16,
                  border: '2px solid',
                  borderColor: form.regionLevel === key ? '#1890ff' : '#e8e8e8',
                  background: form.regionLevel === key ? '#e6f7ff' : '#fff',
                  borderRadius: 12,
                  cursor: 'pointer'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 600, fontSize: 16 }}>{config.name}</span>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#fa8c16' }}>¥{config.fee.toLocaleString()}</span>
                </div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
                  推荐奖 {config.recommendBonus} · 管理奖 {config.manageBonus}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 区域选择 */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, marginBottom: 20 }}>
          <h3 style={{ marginBottom: 16 }}>选择代理区域</h3>
          <select
            value={form.regionId}
            onChange={e => {
              const region = filteredRegions.find(r => r.id == e.target.value)
              setForm({ ...form, regionId: e.target.value, regionName: region?.name || '' })
            }}
            style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9' }}
          >
            <option value="">请选择{currentConfig.name}区域</option>
            {filteredRegions.map(r => (
              <option key={r.id} value={r.id}>{r.name}</option>
            ))}
          </select>
        </div>

        {/* 基本信息 */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, marginBottom: 20 }}>
          <h3 style={{ marginBottom: 16 }}>填写基本信息</h3>
          
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>姓名 *</label>
            <input
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="请输入真实姓名"
              style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>手机号 *</label>
            <input
              type="tel"
              value={form.phone}
              onChange={e => setForm({ ...form, phone: e.target.value })}
              placeholder="请输入手机号"
              maxLength={11}
              style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>登录密码 *</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              placeholder="请设置登录密码（至少6位）"
              minLength={6}
              style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>身份证号（选填）</label>
            <input
              type="text"
              value={form.idCard}
              onChange={e => setForm({ ...form, idCard: e.target.value })}
              placeholder="选填，用于实名认证"
              style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>推荐码（选填）{referrerId && <span style={{color: '#52c41a', marginLeft: 8}}>✓ 已找到推荐人</span>}</label>
            <input
              type="text"
              value={form.recommendCode}
              onChange={e => handleRecommendCodeChange(e.target.value)}
              placeholder="如有推荐人请填写推荐码"
              style={{ width: '100%', padding: 12, fontSize: 14, borderRadius: 8, border: '1px solid #d9d9d9', boxSizing: 'border-box' }}
            />
            <div style={{fontSize: 11, color: '#999', marginTop: 4}}>推荐人注册后获得的ID或推荐码</div>
          </div>
        </div>

        {/* 费用说明 */}
        <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ fontWeight: 600, color: '#fa8c16', marginBottom: 12 }}>💰 费用说明</div>
          <div style={{ fontSize: 14, color: '#666', lineHeight: 1.8 }}>
            <div>代理费：<strong>¥{currentConfig.fee.toLocaleString()}</strong></div>
            <div style={{ marginTop: 8 }}>
              <strong>包含内容：</strong>
              <ul style={{ margin: '4px 0 0', paddingLeft: 20 }}>
                <li>区域独家代理权（1年）</li>
                <li>自动获得该区域推广员资格</li>
                <li>推荐奖 {currentConfig.recommendBonus}</li>
                <li>管理奖 {currentConfig.manageBonus}</li>
              </ul>
            </div>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%',
            padding: 14,
            background: loading ? '#d9d9d9' : '#1890ff',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: 16
          }}
        >
          {loading ? '提交中...' : '提交申请'}
        </button>
      </div>
    </div>
  )
}
